const KEY = 'bs.theme';

export function isDark(): boolean {
  return document.documentElement.classList.contains('dark');
}

export function setTheme(dark: boolean): void {
  document.documentElement.classList.toggle('dark', dark);
  try { localStorage.setItem(KEY, dark ? 'dark' : 'light'); } catch (e) { console.warn('localStorage unavailable; theme not remembered', e); }
}

export function toggleTheme(): void {
  setTheme(!isDark());
}
